<template>
  <section class="band" id="pricing">
    <div class="wrap">
      <div class="head c">
        <h2 class="h2">Pricing</h2>
      </div>
      <div class="tiers mt">
        <div class="card tier soon" aria-label="Lite plan, coming soon"><div class="soon-tag"><em>Lite</em><b>Coming soon</b><span>Simple scheduling for a single site.</span></div>
          <div>
            <span class="eyebrow">Lite</span>
            <div class="amt"><b>$19</b><span>per month + GST</span></div>
          </div>
          <p class="tdesc">For a single site that needs screens scheduled and running.</p>
          <ul>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Scheduling by time of day and weekday</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Live View monitoring</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Unlimited media storage</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Time, news and ticker plugins</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Brightness control and offline playback</li>
          </ul>
          <a class="btn btn-line" href="#start" @click.prevent="$emit('go', '#start')">Start with Lite</a>
        </div>

        <div class="card tier pro">
          <div>
            <div class="tier-top"><span class="eyebrow">Pro</span><span class="tag tag-pop">Most popular</span></div>
            <div class="amt"><b>$69</b><span>per month + GST</span></div>
            <p class="fine">Or $795 per year, billed annually.</p>
          </div>
          <p class="tdesc">For operators selling screen time.</p>
          <ul>
            <li class="incl">Includes</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Scheduling by time of day and weekday</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Private booking across all your screens</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Advertising marketplace with in-platform payments</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Peak, weekend and event pricing, plus coupons</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>e2v inventory automation</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Live View monitoring</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Unlimited media storage</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Booking logs and proof of play reporting</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Team management with multiple users</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Brightness control and offline playback</li>
          </ul>
          <a class="btn btn-red" href="#/home" data-auth="register">Get Adverpost</a>
        </div>

        <div class="tier-col"><div class="card tier net">
          <div>
            <span class="eyebrow">Network</span>
            <div class="amt"><b class="sm">Let’s talk</b></div>
          </div>
          <p class="tdesc">For large and multi-site networks.</p>
          <ul>
            <li class="incl">Everything in Pro, plus</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Multi-tenant and store-level reporting</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Custom e2v data integrations</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Hardware supply and installation</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Service level agreement</li>
            <li><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>Dedicated account manager</li>
          </ul>
          <a class="btn btn-line" href="#demo" data-demo="network">Enquire</a>
        </div>
          <div class="card addon">
            <div class="addon-top"><span class="eyebrow">Add-on</span><span class="tag">New</span></div>
            <h3>Adverpeople analytics</h3>
            <p>Real impressions, attention time and demographics for every campaign on enabled screens.</p>
            <a class="btn btn-line btn-sm" href="#demo" data-demo="adverpeople">Enquire</a>
          </div>
        </div>
      </div>
      <p class="fine tier-note">Prices in AUD. Free trial on request. Setup costs may apply.</p>

      <div class="roi wide mt">
        <div class="roi-l">
          <h3>What one advertiser is worth on Pro</h3>
          <div class="roi-calc">
            <label for="roi-rate">Monthly booking per advertiser <output>{{ figures.rate }}</output></label>
            <input id="roi-rate" v-model.number="rate" type="range" min="100" max="2000" step="50" :style="{ '--p': fill(rate, 100, 2000) }" />
            <label for="roi-adv">Advertisers across your network <output>{{ figures.advertisers }}</output></label>
            <input id="roi-adv" v-model.number="advertisers" type="range" min="1" max="20" step="1" :style="{ '--p': fill(advertisers, 1, 20) }" />
          </div>
        </div>
        <div class="roi-out">
          <div><b>{{ figures.payback }}</b><small>of Pro covered each month</small></div>
          <div><b>{{ figures.net }}</b><small>net revenue per year after Pro</small></div>
        </div>
      </div>
    
    </div>
  </section>
</template>

<script>
// Extracted verbatim from public/landing/index.html; in-page anchors emit
// instead of navigating, because the app uses a hash router.
import { roiFigures } from "./widgets";

export default {
  name: "PricingSection",
  data() {
    return { rate: 500, advertisers: 1 };
  },
  computed: {
    figures() {
      return roiFigures(this.rate, this.advertisers);
    },
  },
  methods: {
    // The track's filled part is painted up to --p (see .roi input[type=range]
    // in _base.scss). The original page set it from a script; binding it here
    // keeps the fill under the thumb instead of a fixed 20%.
    fill(value, min, max) {
      return ((value - min) / (max - min)) * 100 + "%";
    },
  },
};
</script>
